import type { ElementType, HTMLProps, ReactNode, Ref } from 'react'
import cn from 'classnames'
import { withTypographyClassName, wrapTextChildrenWithTypography } from '@/scopes/common/components/Header/typography'
import styles from './TopNavigationBarItem.module.css'

interface TopNavigationBarItemProps extends Omit<HTMLProps<HTMLButtonElement>, 'as'> {
  as?: ElementType
  ref?: Ref<HTMLButtonElement>
  children?: ReactNode
}

function TopNavigationBarItem({ ref, as: Component = 'button', className, children, ...rest }: TopNavigationBarItemProps) {
  return (
    <Component ref={ref} className={cn(styles.topNavigationBarItem, className)} {...rest}>
      {withTypographyClassName(wrapTextChildrenWithTypography(children), styles.text)}
    </Component>
  )
}

export default TopNavigationBarItem
